import URLSearchParams from '@ungap/url-search-params';
import { CHECK_ROUTE_ON_LOAD } from '../actions';
import updateMsisdn from './update-msisdn';

import fetchCustomerDetails from './fetch-customer-details';

export default function checkRouteOnLoad(groupSlug = '') {
  return async (dispatch, getState) => {
    const {
      contact,
      router: {
        location: { search },
      },
      dynamicContent,
    } = getState();

    dispatch({ type: CHECK_ROUTE_ON_LOAD });

    const searchParams = new URLSearchParams(search);
    const msisdn = searchParams.get('msisdn') || searchParams.get('msdn');
    const needToFetchCustomerDetails =
      !contact.customerDetailsPreloaded &&
      msisdn &&
      dynamicContent?.showCustomerLookup;

    if (needToFetchCustomerDetails) {
      dispatch(updateMsisdn(msisdn));
      dispatch(fetchCustomerDetails(msisdn, groupSlug));
    }
  };
}
